import Button from '@/shared/components/button/Button'
import NudgeBanner from '@/shared/components/NudgeBanner'

type PurchaseButtonProps = {
  text: string
  disabled: boolean
  onClick: () => void
  fontSize: string
}

const PurchaseButton = ({ text, onClick, disabled, fontSize }: PurchaseButtonProps) => {
  return (
    <div className="fixed bottom-0 left-[50%] right-0 w-screen max-w-[768px] translate-x-[-50%] px-4 ">
      <NudgeBanner />
      <div className="h-20 bg-010 py-3">
        <Button
          text={text}
          onClick={onClick}
          background="main050"
          color="text010"
          disabled={disabled}
          className={`${fontSize} h-[56px] py-[0px]`}
        />
      </div>
    </div>
  )
}

export default PurchaseButton
